/* eslint-disable */
import { createRouter, createWebHistory } from "vue-router";
import Dashboard from "../views/Dashboard/Dashboard.vue";
import Signin from "../views/Signin.vue";
import perfil from "../views/Perfil.vue";
import editarPerfil from "../views/Dashboard/EditarPerfil.vue";
import NotFound from "../views/404.vue";
import Venta from "../views/Venta.vue";
import VentaDigital from "../views/VentaDigital.vue";
import Invitacion from "../views/Invitacion.vue";
import Landing from "../views/Landing/Index.vue";
import DatosBancarios from "../views/DatosBancarios.vue";
import Terminos from "../views/Terminos.vue";
import Descripcion from "../views/Descripcion.vue";
import Tips from "../views/Tips.vue";
import store from "@/store/index";
import RouletteDashboard from "../views/RouletteDashboard.vue";
import Referidos from "../views/Referidos/Index.vue";
import Mas from "../views/Mas.vue";
import transacciones from "../views/Dashboard/Transacciones.vue";
import detalleVentas from "../views/Dashboard/DetalleVentas.vue";
import Administracion from "../views/Administracion/Index.vue";
import Bees from "../views/Bees/Index.vue";
import recursos from "../views/Dashboard/Recursos.vue";
import vuexStore from "../store/index.js"; // Adjust this path according to your project structure
import PlanesDisponibles from "../views/PlanesDisponibles.vue";
import API from "@/store/axios";

const routes = [
  {
    path: "/",
    name: "landing",
    component: Landing,
    meta: { layout: "full", requiresAuth: false },
  },
  {
    path: "/tips",
    name: "Tips",
    component: Tips,
    meta: { layout: "full", requiresAuth: false },
  },
  {
    path: "/invitacion/:promoCode?",
    name: "Invitacion",
    component: Invitacion,
    meta: { layout: "full" },
  },
  {
    path: "/dashboard/referidos",
    name: "referidos",
    component: Referidos,
    meta: {
      requiresAuth: true,
      layout: "horizontal",
      breadCrumb: "Mi Equipo",
    },
  },
  {
    path: "/dashboard/planes",
    name: "planes",
    component: PlanesDisponibles,
    meta: {
      requiresAuth: true,
      layout: "horizontal",
      breadCrumb: "Planes Disponibles",
    },
  },
  {
    path: "/dashboard/banco",
    name: "banco",
    component: DatosBancarios,
    meta: {
      requiresAuth: true,
      layout: "horizontal",
      breadCrumb: "Cuenta bancaria",
    },
  },
  {
    path: "/dashboard/mas",
    name: "mas",
    component: Mas,
    meta: {
      requiresAuth: true,
      layout: "horizontal",
      breadCrumb: "Otras opciones",
    },
  },
  {
    path: "/dashboard/terminos",
    name: "terminos",
    component: Terminos,
    meta: {
      requiresAuth: true,
      layout: "horizontal",
      breadCrumb: "Términos y condiciones",
    },
  },
  {
    path: "/dashboard/descripcion",
    name: "descripcion",
    component: Descripcion,
    meta: {
      requiresAuth: true,
      layout: "horizontal",
      breadCrumb: "Descripción y Términos de XTRIMPRO",
    },
  },
  {
    path: "/dashboard/roulette",
    name: "roulette",
    component: RouletteDashboard,
    meta: {
      requiresAuth: true,
      layout: "horizontal",
      breadCrumb: "¡Gira la ruleta!",
    },
  },
  {
    path: "/venta",
    name: "VentaDigital",
    component: VentaDigital,
    meta: { layout: "full" },
  },
  {
    path: "/venta/:promoCode",
    name: "Venta",
    component: Venta,
    meta: { layout: "full" },
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    meta: { requiresAuth: true, layout: "horizontal", breadCrumb: "Inicio" },
  },
  {
    path: "/administracion",
    name: "Administracion",
    component: Administracion,
    meta: {
      requiresAuth: true,
      requestAccess: true,
      layout: "horizontal",
      breadCrumb: "Administración",
    },
    children: [
      {
        path: "",
        redirect: { name: "AdminResumen" },
      },
      {
        path: "resumen",
        name: "AdminResumen",
        component: () => import("../views/Administracion/Resumen.vue"),
        meta: {
          requiresAuth: true,
          requestAccess: true,
          layout: "horizontal",
          breadCrumb: "Administración",
        },
      },
      {
        path: "ventas",
        name: "AdminVentas",
        component: () => import("../views/Administracion/ListadoVentas.vue"),
        meta: {
          requiresAuth: true,
          requestAccess: true,
          layout: "horizontal",
          breadCrumb: "Administración",
        },
      },
      {
        path: "retiros",
        name: "AdminRetiros",
        component: () => import("../views/Administracion/ListadoRetiros.vue"),
        meta: {
          requiresAuth: true,
          requestAccess: true,
          layout: "horizontal",
          breadCrumb: "Administración",
        },
      },
      {
        path: "instaladas",
        name: "AdminInstaladas",
        component: () =>
          import("../views/Administracion/ListadoVentasInstaladas.vue"),
        meta: {
          requiresAuth: true,
          requestAccess: true,
          layout: "horizontal",
          breadCrumb: "Administración",
        },
      },
      {
        path: "transacciones",
        name: "AdminTransacciones",
        component: () =>
          import("../views/Administracion/ListadoTransaccionesVentasDirectas.vue"),
        meta: {
          requiresAuth: true,
          requestAccess: true,
          layout: "horizontal",
          breadCrumb: "Administración",
        },
      },
      {
        path: "recursos",
        name: "AdminRecursos",
        component: () => import("../views/Administracion/RecursosAdmin.vue"),
        meta: {
          requiresAuth: true,
          requestAccess: true,
          layout: "horizontal",
          breadCrumb: "Administración",
        },
      },
      {
        path: "usuarios",
        name: "AdminUsuarios",
        component: () =>
          import("../views/Administracion/ListadoUsuarios.vue"),
        meta: {
          requiresAuth: true,
          requestAccess: true,
          layout: "horizontal",
          breadCrumb: "Administración",
        },
      },
      {
        path: "promociones",
        name: "AdminPromociones",
        component: () => import("../views/Administracion/Promociones.vue"),
        meta: {
          requiresAuth: true,
          requestAccess: true,
          layout: "horizontal",
          breadCrumb: "Administración",
        },
      },
      {
        path: "bot",
        name: "AdminBot",
        component: () => import("../views/Administracion/BotTestTab.vue"),
        meta: {
          requiresAuth: true,
          requestAccess: true,
          requiresAdmin: true,
          layout: "horizontal",
          breadCrumb: "Administración",
        },
      },
      {
        path: "mailing",
        name: "AdminMailing",
        component: () =>
          import("../views/Administracion/MailingTestTool.vue"),
        meta: {
          requiresAuth: true,
          requestAccess: true,
          requiresAdmin: true,
          layout: "horizontal",
          breadCrumb: "Administración",
        },
      },
      {
        path: "mailing-campanas",
        name: "AdminMailingCampanas",
        component: () =>
          import("../views/Administracion/MailingCampaignTool.vue"),
        meta: {
          requiresAuth: true,
          requestAccess: true,
          requiresAdmin: true,
          layout: "horizontal",
          breadCrumb: "Administración",
        },
      },
      {
        path: "whatsapp-campanas",
        name: "AdminWhatsAppCampanas",
        component: () =>
          import("../views/Administracion/WhatsAppCampaignTool.vue"),
        meta: {
          requiresAuth: true,
          requestAccess: true,
          requiresAdmin: true,
          layout: "horizontal",
          breadCrumb: "Administración",
        },
      },
      {
        path: "simulador",
        name: "AdminSimulador",
        component: () =>
          import("../views/Administracion/SimuladorInstalaciones.vue"),
        meta: {
          requiresAuth: true,
          requestAccess: true,
          layout: "horizontal",
          breadCrumb: "Administración",
        },
      },
    ],
  },
  {
    path: "/bees",
    name: "Bees",
    component: Bees,
    meta: {
      requiresAuth: true,
      requestAccess: true,
      layout: "horizontal",
      breadCrumb: "BEES",
    },
    children: [
      {
        path: "",
        name: "BeesResumen",
        component: () => import("../views/Bees/Resumen.vue"),
        meta: {
          requiresAuth: true,
          requestAccess: true,
          layout: "horizontal",
          breadCrumb: "BEES",
        },
      },
      {
        path: "leads",
        name: "BeesLeads",
        component: () => import("../views/Bees/Leads.vue"),
        meta: {
          requiresAuth: true,
          requestAccess: true,
          layout: "horizontal",
          breadCrumb: "BEES",
        },
      },
      {
        path: "sales",
        name: "BeesSales",
        component: () => import("../views/Bees/Ventas.vue"),
        meta: {
          requiresAuth: true,
          requestAccess: true,
          layout: "horizontal",
          breadCrumb: "BEES",
        },
      },
      {
        path: "bot",
        name: "BeesBot",
        component: () => import("../views/Bees/Bot.vue"),
        meta: {
          requiresAuth: true,
          requestAccess: true,
          layout: "horizontal",
          breadCrumb: "BEES",
        },
      },
    ],
  },
  {
    path: "/login",
    name: "Signin",
    component: Signin,
    meta: { layout: "full" },
  },
  {
    path: "/crearPerfil",
    name: "crearPerfil",
    component: perfil,
    meta: {
      requiresAuth: true,
      meta: { layout: "full" },
    },
  },
  {
    path: "/dashboard/perfil",
    name: "Perfil",
    component: editarPerfil,
    meta: {
      requiresAuth: true,
      layout: "horizontal",
      breadCrumb: "Editar perfil",
    },
  },

  {
    path: "/resumen",
    redirect: { name: "AdminResumen" },
  },
  {
    path: "/:catchAll(.*)",
    name: "NotFound",
    component: NotFound,
    meta: { layout: "full" },
  },
  {
    path: "/dashboard/transacciones",
    name: "transacciones",
    component: transacciones,
    meta: {
      requiresAuth: true,
      layout: "horizontal",
      breadCrumb: "Mis transacciones",
    },
  },
  {
    path: "/dashboard/ventas",
    name: "ventas",
    component: detalleVentas,
    meta: {
      requiresAuth: true,
      layout: "horizontal",
      breadCrumb: "Mis Referidos",
    },
  },
  {
    path: "/dashboard/recursos",
    name: "recursos",
    component: recursos,
    meta: {
      requiresAuth: true,
      layout: "horizontal",
      breadCrumb: "Recursos",
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

router.beforeEach(async (to, _, next) => {
  var condition = navigator.onLine ? "online" : "offline";
  if (condition === "online") {
    const user = vuexStore.state.user;
    const tokenAuth = vuexStore.state.tokenAuth;
    if (!user) {
      if (
        to.path.startsWith("/venta") ||
        to.path.startsWith("/invitacion") ||
        to.path === "/" ||
        to.path === "/login"
      ) {
        return next(); // Let the navigation proceed
      } else if (to.path === "/login") {
        next(); // Allow the navigation to login
      } else {
        next("/login"); // Redirect to login if not on the login page
      }
    } else {
      if (to.meta.requestAccess) {
        try {
          if (!vuexStore.state.userRole) {
            const response = await API.post("/auth/accessAdminPanel");

            if (!response.data.accessAllowed) {
              return next("/login");
            }
            if (response.data.role) {
              vuexStore.commit("SET_USER_ROLE", response.data.role);
            }
          }

          const requiresAdmin = to.matched.some(
            (record) => record.meta.requiresAdmin,
          );
          if (requiresAdmin && vuexStore.state.userRole !== "admin") {
            return next({ name: "AdminResumen" });
          }

          return next();
        } catch (error) {
          console.error("Access check failed:", error);
          next("/login");
        }
      } else {
        next();
      }
    }
  } else {
    window.location.href =
      window.location.protocol + "//" + window.location.host + "/conexion.html";
  }
});

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

export default router;
